export const iconFontAwesomeCommunicationCommentDots = (
	<i className="fa-solid fa-comment-dots"></i>
);
